<template>

    <crud-container :name="name">
        <modal name="confirmation-saved">
            <h1>Are you sure you want to submit this timesheet?</h1>
            <p>Submitting this timesheet will mean it becomes available for HR to approve and will be uneditable from
                this point forward. Do you want to proceed?</p>
            <div class="actions">
                <a href="#" @click.prevent="closeModal()">Cancel</a>
                <a href="#" @click.prevent="saveItem(true)">Submit</a>
            </div>
        </modal>

        <crud-nav>
            <crud-nav-header title="Your Timesheets" disable-create="true"></crud-nav-header>

            <crud-nav-scroll>
                <h3 v-if="requires_attention_items.length">Requires Attention</h3>
                <ul v-if="requires_attention_items.length">

                    <li v-for="(sheet,index) in requires_attention_items">
                        <div class="uneditable" v-if="index != 0" href="#">
                            Week {{ sheet.week }} ({{ sheet.start }}) - {{ sheet.year }} ({{ sheet.total_hours }} Hours)
                        </div>
                        <a v-if="index == 0" href="#" @click.prevent="viewItem(sheet)">
                            Week {{ sheet.week }} ({{ sheet.start }}) - {{ sheet.year }} ({{ sheet.total_hours }} Hours)
                        </a>
                    </li>
                </ul>

                <h3 v-if="submitted_items.length">Submitted</h3>
                <ul v-if="submitted_items.length">
                    <li v-for="sheet in submitted_items">
                        <a href="#" @click.prevent="viewItem(sheet)">Week {{ sheet.week }} ({{ sheet.start }}) - {{
                            sheet.year }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

                <h3 v-if="approved_items.length">Approved</h3>
                <ul v-if="approved_items.length">
                    <li v-for="sheet in approved_items">
                        <a href="#" @click.prevent="viewItem(sheet)">Week {{ sheet.week }} ({{ sheet.start }}) - {{
                            sheet.year }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

                <h3 v-if="disputed_items.length">Disputed</h3>
                <ul v-if="disputed_items.length">
                    <li v-for="sheet in disputed_items">
                        <a href="#" @click.prevent="viewItem(sheet)">Week {{ sheet.week }} ({{ sheet.start }}) - {{
                            sheet.year }} ({{ sheet.total_hours }} Hours)</a>
                    </li>
                </ul>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new></crud-new>
            <crud-view>
                <div v-if="viewing_current_item">
                    <div v-if="current_item.view_only">
                        <crud-main-header
                                :title="'View Hours For Week '+current_item.week+' <small>('+current_item_date_range+')</small>'"
                                can-go-back-to-nav="true"></crud-main-header>
                        <crud-main-scroll>
                            <timesheet-view :sheet="current_item"></timesheet-view>
                        </crud-main-scroll>
                    </div>
                    <div v-else>
                        <crud-main-header
                                :title="'Update Hours For Week '+current_item.week+' <small>('+current_item_date_range+')</small>'"
                                can-go-back-to-nav="true"></crud-main-header>
                        <crud-main-scroll>
                            <p v-if="current_item.status_note" class="notes"><strong>Notes: </strong>{{
                                current_item.status_note }}</p>

                            <div class="timesheet-entry-container" v-if="current_item.entries.length" v-for="entryDate in current_item.valid_entry_dates">
                                <h3>{{ entryDate | human }}</h3>
                                <div class="timesheet-entries">
                                    <dl class="timesheet-entry" v-for="(entry,index) in current_item.getEntriesByDate(entryDate)">
                                        <dt>Hours</dt>
                                        <dd><input type="number" v-model="entry.hours" pattern="\d*" step=".01"/></dd>
                                        <dt>Night Or Day?</dt>
                                        <dd>
                                            <div class="toggle">
                                                <input class="toggle-input" type="checkbox" v-model="entry.night"/>
                                                <div class="toggle-bg"></div>
                                                <div class="toggle-switch">
                                                    <div class="toggle-switch-figure"></div>
                                                    <div class="toggle-switch-figureAlt"></div>
                                                </div>
                                            </div>
                                        </dd>
                                        <dt>Related To</dt>
                                        <dd>
                                            <v-select :on-search="getPackages" v-model="entry.package"
                                                      placeholder="Associate With A Package..."
                                                      :options="filtered_packages">
                                                <span slot="no-options">No packages found - type to find packages</span>
                                            </v-select>
                                        </dd>
                                        <dt>Comments</dt>
                                        <dd><textarea v-model="entry.comments"></textarea></dd>
                                        <dt v-if="index > 0">&nbsp;</dt>
                                        <dd v-if="index > 0"><a href="#" class="delete-entry"
                                               @click.prevent="current_item.deleteEntry(entry)"><i
                                                class="fa fa-trash"></i> Delete Entry</a></dd>
                                    </dl>
                                    <a href="#" @click.prevent="current_item.addEntry(entryDate)" class="add-entry"><i class="fa fa-plus"></i> Add More</a>
                                </div>
                                <hr />
                            </div>

                            <div class="action-button-group">
                                <a href="#" class="action-button action-button-dismiss hidden-desktop"
                                   @click.prevent="backToNav()">
                                    <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                                </a>
                                <a href="#" class="action-button action-button-dismiss"
                                   @click.prevent="saveItem(false)">
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                                </a>
                                <a href="#" class="action-button action-button-success"
                                   @click.prevent="saveItemAndSubmit()">
                                    <i class="fa fa-clock-o" aria-hidden="true"></i> Submit Timesheet
                                </a>
                            </div>
                        </crud-main-scroll>
                    </div>


                </div>
            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import vSelect from "vue-select";

    export default {
        components: {vSelect},
        data() {
            return {
                name: 'timesheets',
                items: [],
                packages: [],
                new_item: {},
                new_item_entries: {},
                current_item: {},
                mappings: [],
                errors: null
            }
        },
        filters: {
            human: function (dateString) {
                var theDate = new Date(dateString);
                var weekdays = [];

                weekdays[0] = "Sunday";
                weekdays[1] = "Monday";
                weekdays[2] = "Tuesday";
                weekdays[3] = "Wednesday";
                weekdays[4] = "Thursday";
                weekdays[5] = "Friday";
                weekdays[6] = "Saturday";
                
                return weekdays[theDate.getDay()] + ' ' + hdate.prettyPrint(dateString);
            }
        },
        watch: {},
        computed: {
            filtered_packages: function () {
            	if (this.packages.length == 0) return [];
                var that = this;
				var containsAny = function(haystack, arr) {
				    return arr.some(function (v) {
				        return haystack.indexOf(v) >= 0;
				    });
				};
                return _.filter(this.packages, function (item) {
                	return item.is_user_staff == 'yes' || containsAny(item.bookings_for_user,that.current_item.valid_entry_dates)
                });
            },
            disputed_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'disputed';
                });
            },
            requires_attention_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'requires_attention';
                });
            },
            submitted_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'submitted';
                });
            },
            approved_items: function () {
                return _.filter(this.items, function (item) {
                    return item.status === 'approved';
                });
            },
            requires_attention: function () {
                return !_.isEmpty(this.required_dates);
            },
            viewing_current_item: function () {
                return !_.isEmpty(this.current_item);
            },
            current_item_date_range: function () {
                // This will fuck shit up if we don't have exactly 7 days in the array.
                if (this.current_item.entries.length) {
                    return this.current_item.entries[0].date + ' - ' + this.current_item.entries[this.current_item.entries.length - 1].date;
                }

                return 'No Date Range...';
            },
            viewing_new_item: function () {
                return !_.isEmpty(this.new_item);
            },
            new_item_date_range: function () {
                // This will fuck shit up if we don't have exactly 7 days in the array.
                return this.new_item.entries[0] + ' - ' + this.new_item.entries[this.new_item.entries.length - 1];
            }
        },
        methods: {
            getPackages: _.debounce(function (search, loading) {
                if (!search) {
                    return;
                }

                var that = this;
                loading(true);
                that.packages = [];
                axios.get(appUrls.packages.index, {params: {'compacted': true, 'search': search, 'user_limited': true}})
                    .then(response => {
                        _.forEach(response.data.data, function (package_) {
                            that.packages.push({
                                label: package_.project + ' > ' + package_.name + ' ('+ package_.reference+')',
                                value: package_.id,
                                bookings_for_user : package_.bookings_for_user,
                                is_user_staff : package_.is_user_staff,
                            });
                        });
                        loading(false);
                    });
            }, 500),
            closeModal: function () {
                window.eventBus.$emit('modal-close-confirmation-saved');
            },
            saveItemAndSubmit: function () {
                window.eventBus.$emit('modal-open-confirmation-saved');
            },
            saveItem: function (submitted) {
                var that = this;
                that.packages = [];
                var currentItem = $.extend({}, this.current_item);
                var saveUrl = appUrls.timesheets.store;
                var data = {
                    entries: currentItem.entries
                }

                if (!currentItem.creating) {
                    data['timesheet_id'] = currentItem.id;
                }

                if (submitted) {
                    data.submit = true;
                }

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: data
                }).then(function (response) {

                    that.viewItem(Object.create(Timesheet).fromExisting(response.data.data));
                    that.getItems(true);
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
                this.closeModal();
            },
            resetErrors() {
                this.errors = null;
            },
            // The Big Daddy Of Methods - Retrieves all methods.
            getItems(dontSelect) {

                var that = this;
                var url = appUrls.timesheets.index;
                var getVarName = 'timesheet';
                var params = {};
                this.items = [];

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(function (response) {
                        // that.items = response.data.data;
                        _.forEach(response.data.data, function (sheet) {
                            that.items.push(Object.create(Timesheet).fromExisting(sheet));
                        });
                        _.forEach(response.data.meta.required_dates, function (sheet) {
                            that.items.push(Object.create(Timesheet).fromNew(sheet));
                        });

                        if (!dontSelect) {
                            if (that.items.length) {
                                that.viewItem(that.items[0]);
                            }
                        }

                        var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;
                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            }
                        }
                    });
            },
            newItem(item) {
                window.eventBus.$emit('crud-show-new-' + this.name);
                window.eventBus.$emit('crud-new-item-' + this.name, item);
            },
            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;


            if( window.isUsingMobileLayout() )
            {
                this.getItems(true);
            }else{
                this.getItems();
            }

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });

            window.eventBus.$on('crud-new-item-' + this.name, function (item) {
                that.current_item = {};
                that.new_item = item;
                that.new_item_entries = {};


                _.forEach(that.new_item.entries, function (entryDate, index) {
                    that.new_item_entries[index] = {
                        hours: null,
                        night: false,
                        date: entryDate,
                        comments: ''
                    };
                });
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.current_item = $.extend({}, item);
                that.new_item = {};
                that.new_item_entries = {};
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.new_item_entries = {};
                that.new_item = {};
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    h3 {
        font-size: 99%;
    }

    div.uneditable {
        opacity: 0.6;
    }

    /////////////////////////////////////////////////
    // Mixins
    /////////////////////////////////////////////////
    @mixin crater($top, $left, $size) {
        content: '';
        position: absolute;
        top: $top;
        left: $left;
        width: $size;
        height: $size;
        background-color: #EFEEDA;
        border-radius: 100%;
        border: 2px solid #DEE1C5;
    }

    @mixin cloudBubble($top, $right, $width, $height, $deg) {
        content: '';
        display: block;
        position: relative;
        top: $top;
        right: $right;
        width: $width;
        height: $height;
        border: 4px solid #D4D4D2;
        border-radius: 100%;
        border-right-color: transparent;
        border-bottom-color: transparent;
        transform: rotateZ($deg);
        background-color: #fff;
    }

    /////////////////////////////////////////////////
    // Day State
    /////////////////////////////////////////////////
    .toggle {
        position: relative;
        display: inline-block;
        width: 80px;
        height: 40px;
        padding: 4px;
        border-radius: 20px;
        margin-left: 5px;
    }

    .toggle:before,
    .toggle:after {
        content: '';
        display: table;
    }

    .toggle:after {
        clear: both;
    }

    .toggle-bg {
        position: absolute;
        top: -4px;
        left: -4px;
        width: 100%;
        height: 100%;
        background-color: #C0E6F6;
        border-radius: 20px;
        border: 4px solid #81C0D5;
        transition: all .1s cubic-bezier(0.250, 0.460, 0.450, 0.940);
    }

    .toggle-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid red;
        border-radius: 20px;
        z-index: 2;
        opacity: 0;
    }

    .toggle-switch {
        position: relative;
        width: 25px;
        height: 25px;
        margin-left: 38px;
        background-color: #F5EB42;
        border: 2px solid #E4C74D;
        border-radius: 50%;
        transition: all .1s cubic-bezier(0.250, 0.460, 0.450, 0.940);
    }

    .toggle-switch-figure {
        position: absolute;
        bottom: -14px;
        left: -50px;
        display: block;
        width: 80px;
        height: 30px;
        border: 4px solid #D4D4D2;
        border-radius: 20px;
        background-color: #fff;
        transform: scale(0.4);
        transition: all .12s cubic-bezier(0.250, 0.460, 0.450, 0.940);
        &:after {
            @include cloudBubble(-46px, -32px, 25px, 25px, 70deg);
        }
        &:before {
            @include cloudBubble(-19px, -10px, 30px, 30px, 30deg);
        }
    }

    .toggle-switch-figureAlt {
        @include crater(5px, 2px, 2px);

        box-shadow: 42px -7px 0 -3px #FCFCFC,
        75px -10px 0 -3px #FCFCFC,
        54px 4px 0 -4px #FCFCFC,
        83px 7px 0 -2px #FCFCFC,
        63px 18px 0 -4px #FCFCFC,
        44px 28px 0 -2px #FCFCFC,
        78px 23px 0 -3px #FCFCFC;

        transition: all .12s cubic-bezier(0.250, 0.460, 0.450, 0.940);
        transform: scale(0);
    }

    .toggle-switch-figureAlt:before {
        @include crater(-1px, 7px, 5px);
    }

    .toggle-switch-figureAlt:after {
        @include crater(9px, 5px, 2px);
    }

    /////////////////////////////////////////////////
    // Night State
    /////////////////////////////////////////////////
    .toggle-input:checked ~ .toggle-switch {
        margin-left: 0;
        border-color: #DEE1C5;
        background-color: #FFFDF2;
    }

    .toggle-input:checked ~ .toggle-bg {
        background-color: #484848;
        border-color: #202020;
    }

    .toggle-input:checked ~ .toggle-switch .toggle-switch-figure {
        margin-left: 40px;
        opacity: 0;
        transform: scale(0.1);
    }

    .toggle-input:checked ~ .toggle-switch .toggle-switch-figureAlt {
        transform: scale(1);
    }

    dl dd {
        width: 350px;
        max-width: 100%;
    }

    .approved, .disputed, .notes {
        padding: 1em;
        border-radius: $standardBorderRadius;
        background-color: $brand;
        color: #FFF;
        font-size: 14px;
        margin-bottom: 1em;
        &.approved {
            background-color: $green;
        }
        &.disputed {
            background-color: $red;
        }
        @include mobile() {
            text-align: center;
        }
        strong {
            display: block;
            font-size: 18px;
            margin-bottom: 7px;
            @include mobile() {
                text-align: center;
            }
        }
    }

    dl.timesheet-entry {
        border-radius: $standardBorderRadius;
        padding: 1em;
        background-color: #ecf0f1;
        margin-bottom: 1em;
    }

    .timesheet-entry-container {
        @include clearfix();
        @include grid-collapse();
        h3 {
            @include grid-column(2);
        }
        .timesheet-entries {
            @include grid-column(6);
            min-width: 555px;
            max-width: calc(50% - 30px);
        }
        hr{
            clear:both;
            margin:1em 0;
        }

        @include mobile() {
            h3 {
                @include grid-column(12);
            }
            .timesheet-entries {
                @include grid-column(12);
                max-width: none;
                min-width: 0;
            }
        }
    }

    a.delete-entry {
        border-radius: $standardBorderRadius;
        padding: 0.5em;
        background-color: $red;
        color: #fff;
        text-decoration: none;
        float: right;
        &:hover {
            background-color: lighten($red, 10);
        }
        @include mobile(){
            display:block;
            float:none;
        }
    }

    a.add-entry{
        padding: 0.5em;
        border-radius: $standardBorderRadius;
        text-decoration: none;
        background-color: $brand;
        color: #FFF;
        clear: both;
        margin: 0 0 1em 0;
        display: inline-block;
        font-size: 13px;
        &:hover {
            background-color: lighten($brand, 10);
        }
        @include mobile(){
            display:block;
            float:none;
        }
    }

</style>